module.exports = __webpack_public_path__ + "img/headline.80d4510c.png";